import Vue from 'vue'
import Router from 'vue-router';
import store from '../store';
import {EventBus} from '../utils/event-bus'
import {getMenuByListID} from "@/services/role";

Vue.use(Router)

const router= new Router({
  routes: [
    {
      path: '/redirect',
      hidden: true,
      component: resolve => require(['@/pages/index'], resolve),
      children: [
        // {
        //   path: '/redirect/:path*',
        //   component: () => import('@/pages/redirect/index')
        // }
      ]
    },

    {
      path: '/tools/qrcode',
      component: resolve => require(['@/pages/tools/qrcode/index'], resolve),
      hidden: true,
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/tools/mingyixing',
      component: resolve => require(['@/pages/tools/qrcode/mingyixing'], resolve),
      hidden: true,
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/tools/xtrunc_100_100',
      component: resolve => require(['@/pages/tools/qrcode/xtrunc_100_100'], resolve),
      hidden: true,
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/tools/qrcode2',
      component: resolve => require(['@/pages/tools/qrcode/index2'], resolve),
      hidden: true,
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/tools/qrcode3',
      component: resolve => require(['@/pages/tools/qrcode/index3'], resolve),
      hidden: true,
      meta: {
        requireAuth: false
      }
    },

    {
      path: '/tools/qrcode4',
      component: resolve => require(['@/pages/tools/qrcode/index4'], resolve),
      hidden: true,
      meta: {
        requireAuth: false
      }
    },

    {
      path: '/tools/qrcode_wa',
      component: resolve => require(['@/pages/tools/qrcode/index_wa.vue'], resolve),
      hidden: true,
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/tools/qrcode5',
      component: resolve => require(['@/pages/tools/qrcode/index5'], resolve),
      hidden: true,
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/tools/miaoxiang/qrcode',
      component: resolve => require(['@/pages/tools/qrcode/indexMiaoXiang'], resolve),
      hidden: true,
      meta: {
        requireAuth: false
      }
    },


    {
      path: '/tools2/qrcode',
      component: resolve => require(['@/pages/tools/qrcode2/index'], resolve),
      hidden: true,
      meta: {
        requireAuth: false
      }
    },

    {
      path: '/tools2/qrcode2',
      component: resolve => require(['@/pages/tools/qrcode2/index2'], resolve),
      hidden: true,
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/tools2/qrcode3',
      component: resolve => require(['@/pages/tools/qrcode2/index3'], resolve),
      hidden: true,
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/tools2/qrcode4',
      component: resolve => require(['@/pages/tools/qrcode2/index4'], resolve),
      hidden: true,
      meta: {
        requireAuth: false
      }
    },


    {
      path: '/tools/m/qrcode',
      component: resolve => require(['@/pages/tools/qrcode3/index'], resolve),
      hidden: true,
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/tools/m/qrcode2',
      component: resolve => require(['@/pages/tools/qrcode3/index2'], resolve),
      hidden: true,
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/tools/m/qrcode3',
      component: resolve => require(['@/pages/tools/qrcode3/index3'], resolve),
      hidden: true,
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/tools/m/qrcode4',
      component: resolve => require(['@/pages/tools/qrcode3/index4'], resolve),
      hidden: true,
      meta: {
        requireAuth: false
      }
    },

    {
      path: '/tools/m/qrcode5',
      component: resolve => require(['@/pages/tools/qrcode3/index5'], resolve),
      hidden: true,
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/batteryWatchH5',
      title:"参数曲线",
      component: resolve => require(['@/pages/assets/batteryWatchH5/index'], resolve),
      meta: { requireAuth: false, title: "参数曲线"}
    },
    {
      path: '/test',
      title:"参数曲线",
      component: resolve => require(['@/pages/test/index'], resolve),
      meta: { requireAuth: false, title: "参数曲线"}
    },
    {
      path: '/dashboard/analysis',
      name: 'analysis',
      title: "大屏",
      component: resolve => require(['@/pages/dashboard/analysis/index'], resolve),
      meta: {requireAuth: true},
    },

    {
      path: '/',
      name: 'login',
      title: "登录页",
      component: resolve => require(['@/pages/login'], resolve)
    },
    {
      path: '/tokenLogin',
      component:  resolve => require(['@/pages/tokenLogin'], resolve),
      hidden: true,
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/index',
      name: '',
      title: "侧边栏",
      component: resolve => require(['@/pages/index'], resolve),
      meta: { requireAuth: true, title: "侧边栏", },
      children: [
        {
          path: '/productionManagement/personnelManagement',
          name: 'personnelManagement',
          title: "生产人员管理",
          component: resolve => require(['@/pages/productionManagement/personnelManagement'], resolve),
          meta: {requireAuth: true, title: "生产人员管理",}
        },
        {
          path: '/productionManagement/taskManagement/index',
          name: 'taskManagement',
          title: "生产任务管理",
          component: resolve => require(['@/pages/productionManagement/taskManagement/index'], resolve),
          meta: {requireAuth: true, title: "生产任务管理",}
        },
        // {
        //   path: '/productionManagement/factoryManagement/index',
        //   name: 'factoryManagement',
        //   title: "生产厂家管理",
        //   component: resolve => require(['@/pages/productionManagement/factoryManagement/index'], resolve),
        //   meta: {requireAuth: true, title: "生产厂家管理",}
        // },
        {
          path: '/productionManagement/deviceCheck/index',
          name: 'deviceCheck',
          title: "生产检测标准",
          component: resolve => require(['@/pages/productionManagement/deviceCheck/index'], resolve),
          meta: {requireAuth: true, title: "生产检测标准",}
        },
        {
          path: '/productionManagement/report/index',
          name: 'TestReport',
          title: "生产系统接入",
          component: resolve => require(['@/pages/productionManagement/report/index'], resolve),
          meta: {requireAuth: true, title: "生产系统接入",}
        },
        {
          path: '/assets/battery',
          name: 'battery',
          title: "电池列表",
          component: resolve => require(['@/pages/assets/battery/index'], resolve),
          meta: { requireAuth: true, title: "电池列表", }
       },
        {
          path: '/assets/battery/param',
          name: 'batteryParam',
          title: "电池状态总览",
          component: resolve => require(['@/pages/assets/batteryParam/index'], resolve),
          meta: { requireAuth: true, title: "电池状态总览", }
        },
        {
          path: '/assets/battery/param/history',
          name: 'battery',
          title: "单台电池历史数据",
          component: resolve => require(['@/pages/assets/batteryParam/history/index'], resolve),
          meta: { requireAuth: true, title: "单台电池历史数据", }
        },
       {
        path: '/assets/centerControl',
        name: 'centerControl',
        title: "中控列表",
        component: resolve => require(['@/pages/assets/centerControl/index'], resolve),
        meta: { requireAuth: true, title: "中控列表", }
     },

      {
        path: '/assets/centerControlWatch/index',
        name: 'centerControlWatch',
        title: "中控监控",
        component: resolve => require(['@/pages/assets/centerControlWatch/index'], resolve),
        meta: {requireAuth: true, title: "中控监控",}
      },
       {
          path: '/assets/equipmentList',
          name: 'equipmentList',
          title: "电池出库",
          component: resolve => require(['@/pages/assets/equipmentList/index'], resolve),
          meta: { requireAuth: true, title: "电池出库", }
       },
       {
        path: '/assets/centralControlOutStorage',
        name: 'centralControlOutStorage',
        title: "中控出库",
        component: resolve => require(['@/pages/assets/centralControlOutStorage/index'], resolve),
        meta: { requireAuth: true, title: "中控出库", }
     },
        {
          path: '/assets/batteryModel',
          name: 'BatteryModel',
          title: "品牌型号",
          component: resolve => require(['@/pages/assets/devType/index'], resolve),
          meta: { requireAuth: true, title: "品牌型号", }
        },
       {
          path: '/assets/customerList',
          name: 'customerList',
          title: "客户管理",
          component: resolve => require(['@/pages/assets/customerList/index'], resolve),
          meta: { requireAuth: true, title: "客户管理", }
       },
       {
          path: '/appUser/center',
          name: 'CenterAppUser',
          title: "中控用户",
          component: resolve => require(['@/pages/assets/appUser/center/index'], resolve),
          meta: { requireAuth: true, title: "中控用户", }
        },
        {
          path: '/appUser/bms',
          name: 'BMSAppUser',
          title: "BMS用户",
          component: resolve => require(['@/pages/assets/appUser/bms/index'], resolve),
          meta: { requireAuth: true, title: "BMS用户", }
        },
        {
          path: '/appUser/bms/mobile',
          name: 'RegMobile',
          title: "注册手机号",
          component: resolve => require(['@/pages/assets/appUser/mobile/index'], resolve),
          meta: { requireAuth: true, title: "注册手机号", }
        },
        {
          path: '/appUser/feedback',
          name: 'feedback',
          title: "问题反馈",
          component: resolve => require(['@/pages/assets/appUser/feedback/index'], resolve),
          meta: { requireAuth: true, title: "问题反馈", }
        },
       {
          path: '/assets/manufacturersList',
          name: 'manufacturersList',
          title: "厂家管理",
          component: resolve => require(['@/pages/assets/manufacturersList/index'], resolve),
          meta: { requireAuth: true, title: "厂家管理", }
       },
        {
          path: '/brand',
          name: 'brand',
          title: "品牌方",
          component: resolve => require(['@/pages/brand/index'], resolve),
          meta: { requireAuth: true, title: "品牌方", }
        },
       {
          path: '/assets/equipmentAlarmList',
          name: 'equipmentAlarmList',
          title: "电池告警列表",
          component: resolve => require(['@/pages/assets/equipmentAlarmList/index'], resolve),
          meta: { requireAuth: true, title: "电池告警列表", }
        },
        {
          path: '/assets/centralControlAlarm',
          name: 'centralControlAlarm',
          title: "中控告警列表",
          component: resolve => require(['@/pages/assets/centralControlAlarm/index'], resolve),
          meta: { requireAuth: true, title: "中控告警列表", }
        },
        {
          path: '/alarm/push-config/mp',
          name: 'centralControlAlarm',
          title: "MPAlarmPushConfig",
          component: resolve => require(['@/pages/alarm/push-config/mp'], resolve),
          meta: { requireAuth: true, title: "公众号告警推送", }
        },
        {
          path: '/alarm/push-config/sms',
          name: 'SMSAlarmPushConfig',
          title: "短信告警推送",
          component: resolve => require(['@/pages/alarm/push-config/sms'], resolve),
          meta: { requireAuth: true, title: "短信告警推送", }
        },

        {
          path: '/alarm/push-config/voice',
          name: 'centralControlAlarm',
          title: "VoiceAlarmPushConfig",
          component: resolve => require(['@/pages/alarm/push-config/voice'], resolve),
          meta: { requireAuth: true, title: "电话告警推送", }
        },
        {
          path: '/alarm/state/index',
          name: 'AlarmState',
          title: "AlarmState",
          component: resolve => require(['@/pages/alarm/state/index'], resolve),
          meta: { requireAuth: true, title: "电池告警台账", }
        },
        {
          path: '/assets/upperComputer',
          name: 'upperComputer',
          title: "上位机下载",
          component: resolve => require(['@/pages/assets/upperComputer/index'], resolve),
          meta: { requireAuth: true, title: "上位机下载", }
        },
        {
          path: '/assets/batteryWatch/index',
          name: 'BatteryWatch',
          title: "设备监控",
          component: resolve => require(['@/pages/assets/batteryWatch/index'], resolve),
          meta: { requireAuth: true,    title: "设备监控",}
        },
        {
          path: '/assets/getTrack',
          name: 'GetTrack',
          title: "获取轨迹",
          component: resolve => require(['@/pages/assets/getTrack/index'], resolve),
          meta: { requireAuth: true,  title: "获取轨迹", }
        },
        {
          path: '/assets/systemSet/roleAdmin/index',
          name: 'roleAdmin',
          title: "角色管理",
          component: resolve => require(['@/pages/assets/systemSet/roleAdmin/index'], resolve),
          meta: { requireAuth: true, title: "角色管理", }
        },
        {
          path: '/assets/systemSet/accountAdmin/index',
          name: 'accountAdmin',
          title: "账号管理",
          component: resolve => require(['@/pages/assets/systemSet/accountAdmin/index'], resolve),
          meta: { requireAuth: true, title: "账号管理", }
        },
        {
          path: '/assets/systemSet/loginLog/index',
          name: 'loginLog',
          title: "登录日志",
          component: resolve => require(['@/pages/assets/systemSet/loginLog/index'], resolve),
          meta: { requireAuth: true, title: "登录日志", }
        },

        {
          path: "/assets/spacepage",
          name: "spacepage",
          title: "空页面",
          component: resolve => require(['@/pages/assets/spacepage/index'], resolve),
          meta: { requireAuth: true,   title: "空页面", }
        },
        {
          path: "/assets/afterSales",
          name: "afterSales",
          title: "售后工单",
          component: resolve => require(['@/pages/assets/afterSales/index'], resolve),
          meta: { requireAuth: true,   title: "售后工单", }
        },
        {
          path: '/assets/ProductManagement/params',
          name: 'productAssembly',
          title: "上位机参数",
          component: resolve => require(['@/pages/assets/ProductManagement/params'], resolve),
          meta: {requireAuth: true, title: "上位机参数",}
        },
        {
          path: '/assets/bmsRemoteCommand/batchIssuanceParameters',
          name: 'bmsRemoteCommand',
          title: "BMS远程指令",
          component: resolve => require(['@/pages/assets/bmsRemoteCommand/batchIssuanceParameters/index'], resolve),
          meta: {requireAuth: true, title: "BMS远程指令",}
        },
        {
          path: '/assets/bmsRemoteCommand/threeSystemManagement',
          name: 'threeSystemManagement',
          title: "第三方运营系统接入管理",
          component: resolve => require(['@/pages/assets/bmsRemoteCommand/threeSystemManagement/index'], resolve),
          meta: {requireAuth: true, title: "第三方运营系统接入管理",}
        },
        {
          path: '/assets/bmsRemoteCommand/params',
          name: 'bmsParams',
          title: "BMS参数管理",
          component: resolve => require(['@/pages/assets/bmsRemoteCommand/params/index'], resolve),
          meta: {requireAuth: true, title: "BMS参数管理",}
        },
        {
          path: '/assets/assetInventory',
          name: 'AssetInventory',
          title: "资产出入库",
          component: resolve => require(['@/pages/assets/assetInventory/index'], resolve),
          meta: {requireAuth: true, title: "资产出入库",}
        },
        {
          path: '/assets/operationLog/index',
          name: 'operationLog',
          title: "操作日志",
          component: resolve => require(['@/pages/assets/operationLog/index'], resolve),
          meta: { requireAuth: true, title: "操作日志", }
        },
        {
          path: '/upgrade/verUp/index',
          name: 'verUp',
          title: "版本更新日志",
          component: resolve => require(['@/pages/upgrade/verUp/index'], resolve),
          meta: { requireAuth: true, title: "版本更新日志", }
        },
        {
          path: '/upgrade/verUpSet/index',
          name: 'verUpSet',
          title: "版本升级(内部)",
          component: resolve => require(['@/pages/upgrade/verUpSet/index'], resolve),
          meta: { requireAuth: true, title: "版本升级(内部)", }
        },

        {
          path: '/upgrade/verUpSet/updateList',
          name: 'addVerUp',
          title: "新增版本升级",
          component: resolve => require(['@/pages/upgrade/verUpSet/updateList'], resolve),
          meta: { requireAuth: true, title: "新增版本升级", }
        },

        {
          path: '/upgrade/verUpSet/editedList',
          name: 'editVerUp',
          title: "修改版本升级",
          component: resolve => require(['@/pages/upgrade/verUpSet/editedList'], resolve),
          meta: { requireAuth: true, title: "修改版本升级", }
        },


      ]
    }
  ]
})

router.beforeEach(async(to,from,next)=>{
  // next();
  if (to.meta.requireAuth) {
    if(sessionStorage.getItem("token")){
      const hasPermission =store.getters.permission && store.getters.permission.length>0;
      if(hasPermission){
        next()
      }else{
        const ids=await getMenuByListID(sessionStorage.getItem("roleIds"));
        if(ids.data.length==0){
          next({path: '/'})
          return;
        }
        store.dispatch('permission/setPermission', ids.data)
      }
      next();

    }else{
        next({
          path: '/',
          // query: { redirect: to.fullPath }
      })

    }
  }else{
    if(to.path.startsWith("/tools/")){
      next();
      return ;
    }
    if(to.path=="/batteryWatchH5"){
      next();
      return ;
    }
    if(to.path=="/test"){
      next();
      return ;
    }
    if(to.path!=="/"){
      next({ path: '/', });
      }else{
        next();
      }
  }
})
const originalPush = Router.prototype.push

Router.prototype.push = function push (location) {

  return originalPush.call(this, location).catch(err => err)

}
export default router



// WEBPACK FOOTER //
// ./src/router/index.js